import { Component } from "@angular/core";
import {
  faSave,
  faPrint,
  faLink,
} from "@fortawesome/free-solid-svg-icons";
import { FormField } from "src/app/interfaces/form-field.model";
import { NotifierService } from "angular-notifier";
import { ChequeDepositListingService } from "src/app/services/autopac/cheque-deposit-listing.service";
import { DatePipe } from "@angular/common";

@Component({
  selector: "app-cheque-deposit-listing",
  templateUrl: "./cheque-deposit-listing.component.html",
  styleUrls: ["./cheque-deposit-listing.component.css"],
})
export class ChequeDepositListingComponent {
  faSave = faSave;
  faPrint = faPrint;
  faLink = faLink;

  showTable: boolean = false;

  form: FormField[] = [
    {
      type: "date",
      id: "ReceiptDate",
      label: "Receipt Date (dd/mm/yyyy)",
    },
    {
      type: "text",
      id: "DepositName",
      label: "Deposit's Name",
      value: "KOMOCO MOTORS PTE LTD",
    },
    {
      type: "text",
      id: "DepositAccountNumber",
      label: "Deposit's Account Number",
      value: "001 - 062637 - 0",
    },
    {
      type: "const",
      id: "TotalReceiptAmount",
      label: "Total Receipt Amount",
      value: null,
    },
  ];

  headers = [
    {
      title: "CUSTOMER NAME",
      type: "data",
      classes: "max-w-64",
      id: "CustomerName",
    },
    {
      title: "FINANCE COMPANY",
      type: "data",
      classes: "max-w-64",
      id: "BankName",
    },
    {
      title: "OR NUMBER",
      type: "data",
      classes: "max-w-64",
      id: "OrNumber",
    },
    {
      title: "CONTRACT NUMBER",
      type: "data",
      classes: "max-w-64",
      id: "ContractNo",
    },
    {
      title: "SALES CONSULTANT",
      type: "data",
      classes: "max-w-64",
      id: "Salesman",
    },
    {
      title: "RECEIPT AMOUNT",
      type: "data",
      classes: "max-w-64",
      id: "ReceiptAmount",
    },
    {
      title: "BANK IN",
      type: "checkbox",
      id: "BankIn",
    },
  ];

  entries: {
    BankIn: boolean;
    BankName: string;
    BatchNo: string;
    ContractNo: string;
    CustomerName: string;
    InvoiceNo: string;
    OrNumber: string;
    ReceiptAmount: string;
    Salesman: string;
    TerminalNo: string;
  }[] = [];

  constructor(
    private chequeDepositListingService: ChequeDepositListingService,
    private notifier: NotifierService,
    private datePipe: DatePipe,
  ) {}

  ngOnInit() {
    const today: Date = new Date();
    this.getField("ReceiptDate").value = this.datePipe.transform(
      today,
      "YYYY-MM-dd",
    )!;
  }

  showReceipt() {
    const receiptDate = this.getField("ReceiptDate").value;
    this.chequeDepositListingService
      .GetReceipts(
        this.datePipe.transform(receiptDate, "dd/MM/YYYY")!,
      )
      .subscribe({
        next: (response) => {
          this.showTable = true;
          this.getField("TotalReceiptAmount").value =
            response.message;
          this.entries = response.body;
          console.log(this.entries);
        },
        error: (error) => {
          console.log(error);
        },
      });
  }

  print(mode: string) {
    const receiptDate = this.getField("ReceiptDate").value;
    const model = {
      DepositAccountNumber: this.getField("DepositAccountNumber")
        .value,
      DepositName: this.getField("DepositName").value,
      ReceiptDate: this.datePipe.transform(receiptDate, "dd/MM/YYYY"),
      Items: this.entries,
    };
    if (mode == "pdf") {
      this.chequeDepositListingService.print(model).subscribe({
        next: (response) => {
          window.open(response.body.Name, "_blank");
        },
        error: (error) => console.log(error),
      });
    } else if (mode == "excel") {
      this.chequeDepositListingService.export(model).subscribe({
        next: (response) => {
          window.open(response.body.Value, "_blank");
        },
        error: (error) => console.log(error),
      });
    }
  }

  getField(id: string): FormField {
    return (
      this.form.find((f) => f.id === id) || {
        id: "",
        type: "text",
        label: "",
        value: undefined,
      }
    );
  }

  clear() {
    this.form.forEach((item) => {
      item.value = undefined;
    });
  }
}
